import { c as _c } from "react/compiler-runtime";
import { FC, ReactNode } from 'react';
import { BasicProps } from '@/types/common';
import css from './style.module.scss';
const BrandBookFormContainer: FC<BasicProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className={css.container}>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BrandBookFormContainer;